// TourProvider.jsx
import React, { createContext, useContext, useState } from "react";
import Joyride from "react-joyride";

const TourContext = createContext();

export function TourProvider({ children }) {
  const [steps, setSteps] = useState([]);
  const [run, setRun] = useState(false);

  return (
    <TourContext.Provider value={{ setSteps, setRun }}>
      {children}

      <Joyride
        steps={steps}
        run={run} // ✅ use the state
        continuous
        scrollToFirstStep
        showSkipButton
        showProgress
        disableScrolling={false}
        spotlightClicks={true}
        locale={{
          back: "Back",
          close: "Close",
          last: "Done",
          next: "Next",
          skip: "Skip",
        }}
        styles={{
          options: {
            zIndex: 9999,
            primaryColor: "#00B3B0",
            textColor: "#333",
            borderRadius: 10,
          },
          tooltip: {
            padding: 8,
            fontSize: 14,
            maxWidth: 320,
            wordBreak: "break-word",
          },
        }}
        floaterProps={{
          // placement: "bottom", // preferred placement
          disableAnimation: false,
          hideArrow: false,
          offset: 15,
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                padding: 8,
              },
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom", "top", "right", "left"],
              },
            },
          ],
        }}
      />
    </TourContext.Provider>
  );
}

export const useTour = () => useContext(TourContext);
